'use client';

import type { ProductAttributesGroupT } from '../../../../type/product/productAttributes';
import type { ProductToCompareT } from '../../../../type/product/productComparison';
import { Container } from '@vs-shop/ui/container';

import ProductComparisonFooter from './footer/ProductComparisonFooter';
import ProductComparisonTable from './table/ProductComparisonTable';
import ProductsComparisonHeader from '../../../server/page/productsComparison/ProductsComparisonHeader';

import ProductsComparisonEmpty from '../../../../container/productsComparison/ProductsComparisonEmpty';

import { productCodesInComparisonAtom } from '@vs-shop/engine/atom/productsComparison/productsComparison';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';
import { useAtomValue } from '@effect/atom-react';

/*
 * TODO
 *   - [ ] horizontal scroll -> sync -> fix mobile
 *   FUTURE
 *   - [ ] link for sharing
 *   - [ ] design of mobile version is completely different
 * */

type Props = {
  productsToCompare: readonly ProductToCompareT[];
  mergedAttributeGroups: readonly ProductAttributesGroupT[];
};

export default function ProductsComparison({ productsToCompare, mergedAttributeGroups }: Props) {
  const productCodesResult = useAtomValue(productCodesInComparisonAtom);

  const filteredProducts = AsyncResult.match(productCodesResult, {
    onInitial: () => productsToCompare,
    onFailure: () => [],
    // Success --> reorder based on current cookie (handles drag & drop + removal)
    onSuccess: (result) =>
      result.value
        .map((code) => productsToCompare.find((product) => product.code === code))
        .filter((product) => product !== undefined),
  });

  return (
    <div className="flex flex-col bg-background-intense">
      {/* BREADCRUMBS, HEADER */}
      <Container classNameWrapper="bg-background-intense" classNameInner="pb-8 lap:pb-16">
        <ProductsComparisonHeader />
      </Container>

      {/* COMPARISON TABLE */}
      <Container classNameWrapper="bg-background-intense" classNameInner="pb-16 lap:pb-25">
        {filteredProducts.length > 0 ? (
          <div className="flex flex-col gap-5 lap:gap-10">
            <ProductComparisonTable
              products={filteredProducts}
              attributeGroups={mergedAttributeGroups}
            />
            <ProductComparisonFooter products={filteredProducts} />
          </div>
        ) : (
          <ProductsComparisonEmpty />
        )}
      </Container>
    </div>
  );
}
